<div class="iframe-container">
  <div class="urlTextContainer" [dlsTooltip]="template"
       [tooltipCursorAligned]="true"
       [tooltipPosition]="'Bottom'"
       [tooltipClass]="'pt-light'"
       [tooltipShowDelay]="1"
       [tooltipHideDelay]="500">
        <span>Iframe URL: {{iframeSrcTxt}}</span>
  </div>
  <iframe [src]="iframeSrc" id="iframe-id" class="iframe-style"></iframe>
  <ng-template #template>
    <div class="pt-info-tooltip">
      <span class="iframe-test-tooltip">{{iframeSrcTxt}}</span>
    </div>
  </ng-template>
</div>
